import React, { Component } from 'react';
import { ListItem } from 'material-ui/List';
import { MdFileDownload as DownloadIcon } from 'react-icons/md';
import { localize } from 'react-localize-redux';

import Subheader from 'material-ui/Subheader';

class DocumentDownloadListItems extends Component {
  _onListItemSelected(key) {
    window.open(decodeURI(this.props.documents[key].document_url));
  }

  render() {
    const style = {
      left_icon: {
        height: 20,
        width: 20,
        margin: 14,
      },
      subheader: {
        lineHeight: 0,
        padding: '20px 16px 10px 16px',
      },
    };

    const documents = this.props.documents;

    const list_items = Object.keys(documents).map(key => (
      <ListItem
        key={key}
        onClick={this._onListItemSelected.bind(this, key)}
        primaryText={
          <div>
            <span style={{ fontSize: '15px' }}>{documents[key].document_name}</span>
            <span style={{ float: 'right', color: '#6F6F6F' }}>{documents[key].createdAt}</span>
          </div>
        }
        leftIcon={<DownloadIcon style={style.left_icon} />}
      />
    ));

    return (
      <div>
        <Subheader inset={false} style={style.subheader}>
          {this.props.translate(`${this.props.listItemType}`)}
        </Subheader>
        {list_items}
      </div>
    );
  }
}

export default localize()(DocumentDownloadListItems);
